module.exports = __webpack_public_path__ + "img/freelylogo-white.a2aa00f2.svg";